export default __webpack_public_path__ + "static/media/man.6563ccb3.png";